<template>
  <div class="treatment-class-input-form">
    <div
      class="row text-row treatment-large-class"
      v-if="target === 'treatment-classes'"
    >
      <select-box-text-form
        :label="'大分類名'"
        :maxlength="30"
        :placeholder="'30文字まで'"
        :requiredFlg="true"
        :selectData="largeClassesSelectData"
        :selectStyles="{ width: '200px' }"
        :selectValue="treatmentLargeClass.id"
        :textDisabled="Boolean(treatmentLargeClass.id)"
        :textStyles="{ width: '250px' }"
        :textValue="treatmentLargeClass.name"
        @select-input="selectInput"
        @text-input="textInput"
        data-test="large-class-select-box-text-form"
      />
    </div>
    <div class="row name">
      <text-input-form
        :disabled="disabledNameEdit"
        :requiredFlg="true"
        :placeholder="'30文字まで'"
        :maxlength="30"
        :styles="{ width: '350px' }"
        v-model="editClass.name"
        >{{ fieldName }}</text-input-form
      >
    </div>
    <div class="row showFlg">
      <select-box-form
        :selectData="selectData"
        v-model.number="editClass.showFlg"
        >表示設定</select-box-form
      >
    </div>
  </div>
</template>

<script>
import TextInputForm from '@/components/parts/molecules/TextInputForm'
import SelectBoxForm from '@/components/parts/molecules/SelectBoxForm'
import SelectBoxTextForm from '@/components/parts/molecules/SelectBoxTextForm.vue'

export default {
  name: 'TreatmentClassInputForm',

  components: {
    TextInputForm,
    SelectBoxForm,
    SelectBoxTextForm
  },

  props: {
    editClass: { type: Object },
    target: { type: String },
    treatmentLargeClass: { type: Object, default: () => ({}) },
    largeClassesSelectData: { type: Array, default: () => [] }
  },

  data() {
    return {
      selectData: [
        { id: 1, name: '〇' },
        { id: 0, name: '✕' }
      ]
    }
  },

  computed: {
    fieldName() {
      return this.target === 'treatment-classes' ? '分類名' : '大分類名'
    },
    disabledNameEdit() {
      return (
        this.target === 'treatment-large-classes' &&
        this.editClass.defaultTreatmentLargeClassId !== 0
      )
    }
  },
  methods: {
    selectInput(val) {
      this.$emit('select-input', val)
    },
    textInput(val) {
      this.$emit('text-input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.treatment-class-input-form {
  > .row ~ .row {
    margin-top: 25px;
  }
}
</style>
